<template>
  <div id="app">
    <!-- <el-select v-model="lang" @change="changeLanuage">
      <el-option label="中文" value="zh"></el-option>
       <el-option label="English" value="en"></el-option>
    </el-select> -->
    <button class="language" @click="changeLanuage">
      <!-- {{ lang == "zh" ? "English" : "中文" }} -->
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" class="immersive-translate-float-ball-logo-img"><path fill="none" d="M0 0h24v24H0z"></path><path d="M5 15v2a2 2 0 0 0 1.85 1.995L7 19h3v2H7a4 4 0 0 1-4-4v-2h2zm13-5l4.4 11h-2.155l-1.201-3h-4.09l-1.199 3h-2.154L16 10h2zm-1 2.885L15.753 16h2.492L17 12.885zM8 2v2h4v7H8v3H6v-3H2V4h4V2h2zm9 1a4 4 0 0 1 4 4v2h-2V7a2 2 0 0 0-2-2h-3V3h3zM6 6H4v3h2V6zm4 0H8v3h2V6z" fill="rgba(255,255,255,1)"></path></svg>
    </button>
    <el-row type="flex" class="row-bg" justify="center">
      <el-col :span="23">
        <router-view v-wechat-title="$route.meta.title" v-if="isRouterAlive"></router-view>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      isRouterAlive: true
    }
  },
  computed: {
    lang(){
      return this.$i18n.locale;
    }
  },
  methods: {
    reload() {
      this.isRouterAlive = false
      this.$nextTick(function() {
        this.isRouterAlive = true
      })
    },
    changeLanuage() {
      let setLang = "";
      if (this.lang == "zh") {
        setLang = "en";
      } else {
        setLang = "zh";
      }
      // 本地去记录选择的语言
      window.localStorage.setItem("lang", setLang);
      // 更新i18n中的语言
      this.$i18n.locale = setLang;
      this.reload(); // 刷新当前页面
    },
  }
}
</script>

<style>
body{
  margin: 0;
  padding: 0;
}
.language{
  display: flex;
    background: chocolate;
    color: #fff;
    font-size: 16px;
    position: absolute;
    right: 0px;
    top: 3px;
    z-index: 999;
    border: 0px;
    padding: 2px 8px;
    border-radius: 24px 0px 0px 24px;
    align-content: space-around;
    align-items: center;
    flex-direction: row;
}
</style>



// WEBPACK FOOTER //
// src/App.vue